import Swiper from "swiper/bundle";

const init = async () => {
  const swiperObjects = document.querySelectorAll(".swiper:not(.swiper-carousel)");

  swiperObjects.forEach((swiperObject) => {
    if (!(swiperObject instanceof Element)) return;

    const wrapper = swiperObject.querySelector('.swiper-wrapper');
    if (!wrapper) {
      console.warn('Swiper wrapper missing:', swiperObject);
      return;
    }

    let params = {};
    try {
      if (swiperObject.dataset.swiper) {
        params = JSON.parse(swiperObject.dataset.swiper);
      }
    } catch (e) {
      console.error('Failed to parse swiper params:', swiperObject.dataset.swiper, e);
    }

    try {
      new Swiper(swiperObject, params);
    } catch (e) {
      console.error('Failed to initialize Swiper:', e);
    }
  });
};

export { init };